import { useAuth } from '../../../components/AuthContext/context.ts';

export const useAccountUid = () => {
  const { session } = useAuth();
  const accountUid = `${session?.exchange_session?.user.account_uid}`;
  return accountUid;
};
